import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';

@Component({
  selector: 'app-summary-details',
  templateUrl: './summary-details.component.html',
  styleUrls: ['./summary-details.component.css','../shared/css/common.css']
})
export class SummaryDetailsComponent implements OnInit {

  summaryForm = this.summaryFormBuilder.group({});
  summaryFormData: any;
  count: number = 4000;
  formdata : any | null;
  constructor(
    private summaryFormBuilder: FormBuilder, 
    private router: Router,
    
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef
  ) {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata")??"{}");
  this.summaryFormData = this.formdata.summaryDetails; 
  this.payorkey = parseInt(sessionStorage.getItem("payorkey")?? "0"); 
   }
   profileMasterTypeKey:any;
   payorkey : number;
  ngOnInit(): void {
    this.loadPartiesInvolved();
  }
  loadPartiesInvolved(){
    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result)=>{
          
      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if(selectedparty){
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
      }
    })
  }

  summaryDetailsSubmit() {
    if (this.summaryForm.valid) {
    this.formdata.summaryDetails = this.summaryFormData; 
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.router.navigate(['questions']);
    }
  }

  back() {
    this.formdata.summaryDetails = this.summaryFormData; 
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    if (this.profileMasterTypeKey === 1) {
      this.router.navigate(['provider']);
    }
    else if (this.profileMasterTypeKey === 2) {
      this.router.navigate(['member']);
    }
    else if (this.profileMasterTypeKey === 3) {
      this.router.navigate(['nonEnumeratedProvider']);
    }
    else if (this.profileMasterTypeKey === 4) {
      this.router.navigate(['nonEnumeratedOrganization']);
    }
    else if (this.profileMasterTypeKey === 5) {
      this.router.navigate(['nonEnumeratedIndividual']);
    }
  }

  valueChangeEvent(data: any) {
  }

}
